import { apiCall } from './base';

export const fetchExperienceProjects = (hash) =>
  apiCall(`/experiences/${hash}/projects`);
  
export const deleteExperienceProjects = (hash, { immediately = false, ...data }) =>
  apiCall(`/experiences/${hash}/projects`, { method: 'DELETE', data, immediately });

export const updateExperience = (hash, { immediately = false, ...data }) =>
  apiCall(`/experiences/${hash}`, { method: 'PUT', data, immediately });

